import { useState } from "react";
import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";

import { allocationImports } from "../../api/endpoints/allocationImports";
import { qk } from "../../api/queryKeys";
import { ErrorBanner } from "../../components/ui/ErrorBanner";

export function ImportRunnerPanel({
  canWrite, gateLatestRunId,
}: {
  canWrite: boolean; gateLatestRunId: string | null;
}) {
  const qc = useQueryClient();
  const [openId, setOpenId] = useState<string | null>(gateLatestRunId);
  const list = useQuery({
    queryKey: qk.allocationImports(),
    queryFn: () => allocationImports.list().then((r) => r.data),
  });
  const detail = useQuery({
    enabled: Boolean(openId),
    queryKey: qk.allocationImport(openId ?? ""),
    queryFn: () => allocationImports.get(openId as string).then((r) => r.data),
  });
  const run = useMutation({
    mutationFn: () => allocationImports.run(),   // no body
    onSuccess: (r) => {
      void qc.invalidateQueries({ queryKey: qk.allocationImports() });
      void qc.invalidateQueries({ queryKey: qk.allocationGate() });
      void qc.invalidateQueries({ queryKey: qk.allocationLedger() });
      setOpenId(r.data.id);
    },
  });

  return (
    <div style={{ padding: 12, border: "1px solid var(--border)", borderRadius: 8 }}>
      <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
        <strong>Legacy import runs</strong>
        <button type="button" style={{ marginLeft: "auto" }} disabled={!canWrite || run.isPending} onClick={() => run.mutate()}>
          {run.isPending ? "Running…" : "Run import"}
        </button>
      </div>
      {run.error && <ErrorBanner error={run.error} title="Import failed" />}
      {list.data?.map((r) => (
        <button key={r.id} type="button" onClick={() => setOpenId(r.id)} style={{ display: "block", textAlign: "left", width: "100%", padding: "4px 0", background: "transparent", border: "none", color: "var(--text)", cursor: "pointer" }}>
          {r.id} · {r.status}
        </button>
      ))}
      {detail.data && (
        <div style={{ marginTop: 8, fontSize: "0.85rem" }}>
          <div className="label">Findings / conflict report</div>
          {(detail.data.report?.findings ?? []).length === 0
            ? <p style={{ color: "var(--text-dim)" }}>No findings.</p>
            : <pre style={{ whiteSpace: "pre-wrap" }}>{JSON.stringify(detail.data.report?.findings, null, 2)}</pre>}
        </div>
      )}
    </div>
  );
}
